// Configuración SEO para VoyBus
export const SITE_CONFIG = {
  name: 'VoyBus',
  title: 'VoyBus - Paquetes de Viaje y Excursiones desde Uruguay',
  description: 'Agencia de viajes uruguaya especializada en excursiones, paquetes grupales y viajes en bus. Viajes accesibles con financiación a Argentina, Brasil y todo Latinoamérica. Desde Montevideo e Interior.',
  url: 'https://voybus.com', // TODO: Actualizar con el dominio real
  defaultImage: '/isotipo.svg',
  defaultOGImage: '/voybus-logo-og.jpg', // Imagen genérica para Open Graph (1200x630px recomendado)
  locale: 'es_UY',
  twitterHandle: '@voybus', // TODO: Actualizar si tienen Twitter
  // Agregar para referencia en schemas
  organizationName: 'VoyBus',
  organizationUrl: 'https://voybus.com',
};

// Función para construir URLs canónicas
export const getCanonicalUrl = (path: string = ''): string => {
  const baseUrl = SITE_CONFIG.url.replace(/\/$/, '');
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${baseUrl}${cleanPath}`;
};

// Función para truncar texto para meta descriptions
export const truncateText = (text: string, maxLength: number = 160): string => {
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength - 3) + '...';
};

// Función para generar keywords desde datos
export const generateKeywords = (
  baseKeywords: string[],
  additionalKeywords: string[] = []
): string => {
  const allKeywords = [...baseKeywords, ...additionalKeywords];
  return allKeywords.join(', ');
};

